define(
    'views/page-sidebar-controller',[
        'jquery',
        'utils/view'
    ],

    function ($, View) {
        var pageSidebar = (function() {
            function pageSidebar() {}

            pageSidebar.prototype.init = function() {
                $('.toggle-menu.open ul').each(function () {
                    var ul = $(this);

                    ul.height(ul[0].scrollHeight);
                });

                $(".toggle-menu").on("click",function() {
                    var _this = this;
                    var ul = $(this).find("ul");

                    if ( $(this).hasClass("close") ) {
                        $(_this).removeClass("close").addClass("open");
                        ul.height(ul[0].scrollHeight);
                    } else {
                        $(_this).removeClass("open").addClass("close");
                        ul.height(0);
                    }
                });
            };

            return pageSidebar;
        })();

        return View('pageSidebar', function () {

            // Depricated. Logic was changed. 
                       
            /* var sidebar = new pageSidebar();
            sidebar.init();*/
        });
    }
);
